import { CustomerDisplayActions } from 'src/common/redux/reducers/customer-display-reducer';
import { CustomerDisplayScreen } from 'src/customer-display/enum/customer-display.enum';
import { getPinPadConfig } from 'src/devices/payment/pinpad-utils';
import { showLoginScreen } from 'src/login/components/show-login-screen';
import { LocalStorage } from '../../common/helpers/local-storage';
import { store } from '../../common/redux/configure-store';
import { LoginActions } from '../../common/redux/reducers/login-reducer';
import { popupMessage } from '../../messages/business-logic/popup-message';
import { clearPinPad } from './../../devices/payment/pinpad-operations';
import { idmLockUserService } from './service/idm-lock-user-service';
import { ItemListActions } from 'src/common/redux/reducers/item-list-reducer';

/**
 * Lock the user out of session regardless if there is an error.
 * Lockout with error will redirect to normal login instead of unlock
 * @returns nothing.
 */
export const lockUser = async (): Promise<void> => {
  const userName = store.getState().user.userName || '';
  const trainingModeActive = store.getState().posMode.trainingMode;

  try {
    await idmLockUserService(userName);
    lockout(userName, trainingModeActive);
    store.dispatch(ItemListActions.removeAllRecords());
    showLoginScreen();
  } catch (err) {
    popupMessage(err);
    setTimeout(showLoginScreen, 2500);
  } finally {
    if (store.getState().pinPad.isPinpadConfigured) {
      await clearPinPad();
    }

    if (store.getState().posMode.trainingMode) {
      const storeNumber = getPinPadConfig()?.StoreNumber;
      if (storeNumber && storeNumber !== LocalStorage.storeId()) {
        LocalStorage.setStoreId(storeNumber);
      }
    }
  }
};

const lockout = (userName: string, trainingModeActive: boolean): void => {
  store.dispatch(CustomerDisplayActions.setScreen(CustomerDisplayScreen.LockedScreen));
  store.dispatch(LoginActions.setLockout());
  LocalStorage.setLockUser(userName, trainingModeActive);
};

export const idleTimeout = (): number => {
  let timeout = 0;
  const idleTimeout = store.getState().touchPoint.touchPointConfiguration.idleTime;
  const data = idleTimeout?.split(':');
  if (data && data.length === 3) {
    const hours = data[0];
    const minutes = data[1];
    const seconds = data[2];
    timeout = parseInt(hours) * 60 * 60 * 1000;
    timeout += parseInt(minutes) * 60 * 1000;
    timeout += parseInt(seconds) * 1000;
  }

  return timeout;
};
